import React from "react";
import { AzuerIcon } from "../CustomIcons";
import { Alert, Button, IconButton, Snackbar, Typography } from "@mui/material";
import { useMsal, useAccount, MsalProvider } from "@azure/msal-react";
import { ACCESS_TOKEN } from "../Login";
import Service from "../../../util/Service";
import { Close } from "@mui/icons-material";

// const configuration = {
//     auth: {
//         clientId: "20b86767-55c9-41fa-888f-cb3a958ea6c4",
//         authority: "https://login.microsoftonline.com/7138408e-9fd9-4e00-9834-c2c0ecca6870",
//     }
// };

// const pca = new PublicClientApplication(configuration);
//await pca.initialize();

export default function AzureLogin() {
    const { instance, accounts, inProgress } = useMsal();
    const account = useAccount(accounts[0] || {});
    const [profile, setProfile] = React.useState();
    const [azure, setAzure] = React.useState();

    const [erro, setErro] = React.useState(null);

    React.useEffect(() => {
        if (account) {
            instance.acquireTokenSilent({
                scopes: ["User.Read"],
                account: account
            }).then((response) => {

                if (response) {
                    // callMsGraph(response.accessToken).then((result) => setApiData(result));                    
                    setAzure(response);
                    // const headers = new Headers();
                    // const bearer = `Bearer ${response.accessToken}`;
                    // headers.append("Authorization", bearer);
                    // const options = {
                    //     method: "GET",
                    //     headers: headers
                    // };
                    // fetch("https://graph.microsoft.com/v1.0/me", options)
                    //     .then(response => response.json(). then(r =>{
                    //         console.log( r );
                    //         setProfile(r);
                    //         setWait(false);
                    //     }))
                    //     .catch(error => console.log(error));


                    // getAuthorities(response);
                }
            }).catch(erro => {
                console.error(erro);
                setErro(JSON.stringify(erro))
            });
        }
    }, [accounts, instance]);

    // function getAuthorities(response) {
    //     const token = response.accessToken;
    //     Service.GET("/api/security/azure/authorities", token)
    //         .then(r => {
    //             
    //             setProfile({
    //                 nome: response.account.name,
    //             })
    //         }).catch(erro => {
    //             
    //             debugger
    //             montaSeNecessario(response)
    //         })
    // }
    // function montaSeNecessario(response) {
    //     const token = response.accessToken;

    //     // if( erro === "Acesso não permitido: /api/security/azure/authorities")
    //     {
    //         const dado = {
    //             jwt: token
    //         }
    //         Service.POST("/api/azure/userToken", dado)
    //             .then(r => {

    //                 if (r.success) {
    //                     setProfile(r.dado);
    //                 }else{
    //                     setProfile({
    //                         nome: response.account.name,
    //                     })
    //                 }
    //             })
    //             .catch(erro => {
    //                 console.log( erro )
    //                 setErro(erro)
    //             })
    //     }
    // }
    function handleLogar() {
        if (!azure) {
            try {
                instance.loginPopup({}).then(r => {
                    localStorage.setItem(ACCESS_TOKEN, r.accessToken);
                    //const page = localStorage.getItem("page");                
                    window.location.href = "/";

                });
            } catch (err) {
                setErro("Falha no login: " + err)
                // handle error
            }
        } else {
            const token = azure.accessToken;
            const dado = {
                jwt: token
            }
            Service.POST("/api/azure/userToken", dado).then(r => {
                if (r.success) {
                    localStorage.setItem(ACCESS_TOKEN, azure.accessToken);
                    window.location.href = "/";
                } else {
                    setErro(r.msg)
                }
            })
        }
    }
    function btnLabel() {
        if (accounts.length > 0) {
            return "Logar como " + (account ? account.name : "");
        }
        return 'Logar com Azure da Very'
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setErro(null);
    };
    function getErro() {
        if (typeof erro === 'string') return erro;
        else return JSON.stringify(erro);
    }

    return (
        <React.Fragment>
            {/* <MsalProvider instance={pca}> */}

            <Button
                type="submit"
                fullWidth
                variant="outlined"
                onClick={handleLogar}
                startIcon={<AzuerIcon />}
            >
                {profile && "Logar como " + profile.nome}
                {!profile && btnLabel()}
            </Button>

            {/* </MsalProvider> */}
            <Snackbar
                open={erro != null}
                //autoHideDuration={5000}
                onClose={handleClose}
                //message={getErro()}
                action={
                    <React.Fragment>                        
                        <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={handleClose}
                        >
                            <Close fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            >
                <Alert
                    onClose={handleClose}
                    severity="info"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {getErro()}
                    <Typography variant="h4" align="center">Informe responsável</Typography>
                </Alert>
            </Snackbar>
        </React.Fragment>
    )
}